import '../style/date-range-picker-sUxv_ad4.css'
import { defineComponent as ie, inject as ye, reactive as _e, ref as f, computed as C, watch as k, openBlock as p, createBlock as P, unref as o, withCtx as O, withDirectives as q, createElementBlock as g, withKeys as U, withModifiers as L, createElementVNode as ee, toDisplayString as Y, createVNode as b, Fragment as re, renderList as le, normalizeClass as te, createTextVNode as ue, renderSlot as me, useModel as Me, toRef as ge, provide as Oe, readonly as oe, createCommentVNode as be, KeepAlive as he, Transition as se } from "vue";
import m from "dayjs";
import "x-utils";
import { BaseSizeEnum as ke } from "./constant/common.js";
import "@vueuse/core";
import "lodash-es";
import { useFormItem as Ve } from "./hooks/useFormItem.js";
import { UPDATE_MODEL_VALUE as ae, CHANGE_EVENT as J } from "./constant/events.js";
import { useI18n as pe } from "./hooks/useLocale.js";
import "./hooks/useGlobalDark.js";
import "./layout/model/Model.js";
import "./layout/DockLocation.js";
import "./layout/Orientation.js";
import "./layout/model/TabNode.js";
import "./layout/model/TabSetNode.js";
import "./layout/model/BorderNode.js";
import Pe from "./input.js";
import Ce from "./icon-button.js";
import De from "./option-list.js";
import { Button as Ee } from "./button.js";
import { useInputSize as Se } from "./hooks/useInputSize.js";
import { DATE_PICKER_CONTEXT_KEY as ce, DatePickerPanel as $e, DATE_FORMAT_MAP as we, DatePickerWrapper as ze, DatePickerYearPanel as Ye, YEAR_COUNT_MAP as xe, DATE_PICKER as Te, DatePickerMonthPanel as Ae } from "./date-picker.js";
import Ne from "dayjs/plugin/objectSupport";
import Q from "./directives/ripple.js";
import { PLAIN_RIPPLE_SETTING as Z } from "./constant/ripple.js";
import de from "./icon.js";
const z = {
  start: null,
  end: null
}, Ke = ["title", "onClick", "onKeydown"], Be = /* @__PURE__ */ ie({
  name: "e-date-range-panel",
  __name: "date-range-panel",
  props: {
    modelValue: {}
  },
  emits: [ae, "selectYear", "selectMonth"],
  setup(j, { emit: F }) {
    m.extend(Ne);
    const x = j, { t: u } = pe(), T = u("datePicker.weekDays").split("|"), G = u("datePicker.yearMonths").split("|"), i = ye(ce), V = m(), e = _e(x.modelValue), d = f(i.selectedMonth.value.startOf("M")), D = C(() => {
      const t = [d.value];
      let n = d.value;
      for (let r = 0; r < d.value.day(); r++)
        n = n.subtract(1, "day"), t.unshift(n);
      for (n = d.value.add(1, "day"); t.length < 42; )
        t.push(n), n = n.add(1, "day");
      return t;
    });
    k(() => x.modelValue, (t) => {
      e.start = t.start, e.end = t.end;
    }, { deep: !0 });
    const h = (t) => !e.start || !e.end ? !1 : t.isSame(e.end, "date") || t.isSame(e.start, "date") ? !0 : t.isBefore(e.end) && t.isAfter(e.start), _ = (t, n) => h(t) && n % 7 === 0 ? !0 : t.valueOf() === e.start?.valueOf() && e.end, E = (t, n) => h(t) && (n + 1) % 7 === 0 ? !0 : t.endOf("date").valueOf() === e.end?.valueOf() && e.start, S = (t) => t.valueOf() === e.start?.valueOf() || t.endOf("date").valueOf() === e.end?.valueOf(), H = (t) => t.valueOf() === V.valueOf(), $ = (t) => t.month() === d.value.month(), M = C(() => i.min ? +d.value <= +i.min : !1), A = C(() => i.max ? +D.value[D.value.length - 1] > +i.max : !1), N = (t) => !!(i.max && +i.max < +t || i.min && +i.min > +t), K = () => {
      d.value = d.value.subtract(1, "M").startOf("M");
    }, B = () => {
      d.value = d.value.add(1, "M").startOf("M");
    }, c = F, v = (t) => {
      N(t) || (!e.start && !e.end ? e.start = t : e.start && !e.end ? t.isBefore(e.start) ? (e.end = e.start.endOf("date"), e.start = t) : e.end = t.endOf("date") : (e.start = t, e.end = null), c(ae, e));
    };
    return k(i.selectedMonth, (t) => {
      d.value = t.startOf("M");
    }), k(i.selectedYear, (t) => {
      d.value = m({ year: t, month: d.value.month(), date: 1 });
    }), (t, n) => (p(), P(o($e), {
      "prev-disabled": M.value,
      "next-disabled": A.value,
      columns: 7,
      class: "e-drp-panel",
      onPrev: K,
      onNext: B
    }, {
      title: O(() => [
        q((p(), g("div", {
          class: "e-dp-panel__select-button",
          role: "button",
          tabindex: "0",
          onClick: n[0] || (n[0] = (r) => c("selectMonth")),
          onKeydown: n[1] || (n[1] = U(L((r) => c("selectMonth"), ["stop"]), ["enter"]))
        }, [
          ee("div", null, Y(o(G)[d.value.month()]), 1),
          b(o(de), {
            icon: "caret-down",
            size: "20"
          })
        ], 32)), [
          [o(Q), o(Z)]
        ]),
        q((p(), g("div", {
          class: "e-dp-panel__select-button",
          role: "button",
          tabindex: "0",
          onClick: n[2] || (n[2] = (r) => c("selectYear")),
          onKeydown: n[3] || (n[3] = U(L((r) => c("selectYear"), ["stop"]), ["enter"]))
        }, [
          ee("div", null, Y(d.value.year()), 1),
          b(o(de), {
            icon: "caret-down",
            size: "20"
          })
        ], 32)), [
          [o(Q), o(Z)]
        ])
      ]),
      default: O(() => [
        (p(!0), g(re, null, le(o(T), (r) => (p(), g("div", {
          key: r,
          class: "e-date-picker__week"
        }, Y(r), 1))), 128)),
        (p(!0), g(re, null, le(D.value, (r, w) => (p(), g("div", {
          key: w,
          class: te(["e-dr-item", {
            "e-dr-item--range": h(r),
            "e-dr-item--selected": S(r),
            "e-dr-item--start": _(r, w),
            "e-dr-item--end": E(r, w)
          }]),
          role: "button",
          tabindex: "0",
          title: r.format("YYYY-MM-DD"),
          onClick: (W) => v(r),
          onKeydown: U(L((W) => v(r), ["stop"]), ["enter"])
        }, [
          q((p(), g("div", {
            class: te(["e-dp-panel__item", {
              "e-dp-panel__item--current": H(r),
              "e-dp-panel__item--selected": S(r),
              "e-dp-panel__item--grey": !$(r),
              "e-dp-panel__item--disabled": N(r)
            }])
          }, [
            ue(Y(r.date()), 1)
          ], 2)), [
            [o(Q), o(Z)]
          ])
        ], 42, Ke))), 128)),
        me(t.$slots, "bottom")
      ]),
      _: 3
    }, 8, ["prev-disabled", "next-disabled"]));
  }
}), Ie = { class: "e-date-picker-buttons" }, ct = /* @__PURE__ */ ie({
  name: "e-date-range-picker",
  __name: "date-range-picker",
  props: {
    modelValue: { default: () => z },
    wrapper: {},
    rangeOptions: {},
    disabled: { type: Boolean },
    clearable: { type: Boolean, default: !0 },
    placeholder: { default: "Select Date" },
    size: {},
    format: {},
    max: {},
    min: {},
    popperProps: {},
    modalProps: {},
    theme: {},
    isError: { type: Boolean, default: void 0 },
    errorMessage: {},
    infoMessage: {}
  },
  emits: [ae, J],
  setup(j, { expose: F, emit: x }) {
    const u = j, T = x, { t: G } = pe(), i = (a) => {
      if (!a) return z;
      const { start: l, end: s } = a;
      return {
        start: l ? m(l).startOf("date") : null,
        end: s ? m(s).endOf("date") : null
      };
    }, V = Me(u, "modelValue", {
      local: !0
    }), e = f(i(u.modelValue)), d = f(), { formSize: D } = Ve(), { actualSize: h } = Se({
      formSize: D,
      propSize: ge(u, "size"),
      defaultSize: ke.Small
    }), _ = f(!1), E = C(() => u.format || we.DATE_RANGE_PICKER), S = C(() => u.rangeOptions?.map((a) => {
      const { text: l, value: s, type: I, times: X = 1 } = a;
      let y;
      return s ? (y = typeof s == "function" ? s() : s, y = {
        start: m(y.start).startOf("date"),
        end: m(y.end).endOf("date")
      }) : y = {
        start: m().subtract(X, I === "m" ? "M" : I).add(1, "day").startOf("date"),
        end: m().endOf("date")
      }, {
        value: y,
        text: l
      };
    })), H = C(() => ({
      disabled: u.disabled,
      triggerByHover: !1,
      transition: "slide",
      lazy: !0,
      offsetSkid: 0,
      offsetDistance: 0,
      placement: "bottom-start",
      ...u.popperProps
    })), $ = (a) => {
      if (!a) return "";
      const { start: l, end: s } = a;
      return !l || !s ? "" : `${m(l).format(E.value)} - ${m(s).format(E.value)}`;
    }, M = f($(e.value)), A = (a) => {
      a && (e.value = {
        start: a.start,
        end: a.end
      });
    }, N = (a) => {
      A(a), d.value = void 0;
    }, K = () => {
      e.value.end && !e.value.start ? e.value = {
        start: e.value.end.clone().startOf("date"),
        end: e.value.end
      } : e.value.start && !e.value.end && (e.value = {
        start: e.value.start,
        end: e.value.start.clone().endOf("date")
      }), B(e.value), V.value = e.value, T(J, e.value, M.value), _.value = !1;
    };
    k(V, (a) => {
      const l = i(a);
      e.value = l, B(l);
    }), k(e, (a) => {
      const l = a.start?.month(), s = a.end?.month(), I = a.start?.year(), X = a.end?.year(), y = n.value.month(), ne = v.value, R = a.end || a.start;
      l !== y && s !== y && R && (n.value = R), I !== ne && X !== ne && R && (v.value = R.year());
    }), k(_, (a) => {
      a || (r(), e.value = i(V.value), d.value = void 0);
    });
    const B = (a) => {
      M.value = $(a);
    }, c = f(!1), v = f(e.value.end?.year() || m().year()), t = f(!1), n = f(e.value.end || m());
    Oe(ce, {
      size: h.value,
      selectedYear: oe(v),
      selectedMonth: oe(n),
      max: u.max ? u.max.startOf("date") : void 0,
      min: u.min ? u.min.startOf("date") : void 0
    });
    const r = () => {
      c.value = !1, t.value = !1;
    }, w = (a) => {
      n.value = m({ y: a, M: n.value.month(), d: 1 }), c.value = !1;
    }, W = (a) => {
      v.value = a.year(), t.value = !1;
    }, fe = f(null), ve = () => {
      e.value = z, M.value = "", V.value = z, T(J, z, "");
    };
    return k(E, () => {
      M.value = $(e.value);
    }), F({
      open() {
        _.value = !0;
      },
      close() {
        _.value = !1;
      }
    }), (a, l) => (p(), P(o(ze), {
      modelValue: _.value,
      "onUpdate:modelValue": l[5] || (l[5] = (s) => _.value = s),
      "popper-props": H.value,
      "modal-props": a.modalProps,
      wrapper: a.wrapper,
      theme: a.theme,
      variant: "date-range-picker"
    }, {
      trigger: O(() => [
        me(a.$slots, "default", { displayText: M.value }, () => [
          b(o(Pe), {
            "model-value": M.value,
            readonly: "",
            disabled: a.disabled,
            clearable: a.clearable,
            placeholder: a.placeholder,
            size: o(h),
            "is-error": a.isError,
            "info-message": a.infoMessage,
            "error-message": a.errorMessage,
            onClear: ve
          }, {
            suffix: O(() => [
              b(o(Ce), {
                icon: "calendar",
                size: "sm"
              })
            ]),
            _: 1
          }, 8, ["model-value", "disabled", "clearable", "placeholder", "size", "is-error", "info-message", "error-message"])
        ])
      ]),
      picker: O(() => [
        S.value ? (p(), g("div", {
          key: 0,
          class: te(["e-date-range-picker-options", `e-date-range-picker-options--${a.size}`])
        }, [
          b(o(De), {
            modelValue: d.value,
            "onUpdate:modelValue": l[0] || (l[0] = (s) => d.value = s),
            items: S.value,
            onSelectOption: A
          }, null, 8, ["modelValue", "items"])
        ], 2)) : be("", !0),
        (p(), P(he, null, [
          b(se, {
            name: "fade",
            mode: "out-in",
            duration: 100
          }, {
            default: O(() => [
              c.value ? (p(), P(o(Ye), {
                key: 0,
                modelValue: v.value,
                "onUpdate:modelValue": l[1] || (l[1] = (s) => v.value = s),
                "display-count": o(xe)[o(Te)],
                onChange: w,
                onClose: r
              }, null, 8, ["modelValue", "display-count"])) : t.value ? (p(), P(o(Ae), {
                key: 1,
                modelValue: n.value,
                "onUpdate:modelValue": l[2] || (l[2] = (s) => n.value = s),
                embedded: "",
                onChange: W,
                onClose: r
              }, null, 8, ["modelValue"])) : (p(), P(Be, {
                key: 2,
                ref_key: "panel",
                ref: fe,
                "model-value": e.value,
                "onUpdate:modelValue": N,
                onSelectYear: l[3] || (l[3] = (s) => c.value = !0),
                onSelectMonth: l[4] || (l[4] = (s) => t.value = !0)
              }, null, 8, ["model-value"]))
            ]),
            _: 1
          })
        ], 1024)),
        ee("div", Ie, [
          b(se, {
            name: "fade",
            mode: "out-in",
            duration: 100
          }, {
            default: O(() => [
              b(o(Ee), {
                text: "",
                block: "",
                size: o(h),
                onClick: K,
                onKeydown: U(L(K, ["stop"]), ["enter"])
              }, {
                default: O(() => [
                  ue(Y(o(G)("datePicker.done")), 1)
                ]),
                _: 1
              }, 8, ["size", "onKeydown"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "popper-props", "modal-props", "wrapper", "theme"]));
  }
});
export {
  ct as default
};
//# sourceMappingURL=date-range-picker.js.map
